export function GetTypes<T extends Record<string, string | number>>(e: T) {
  return Object.keys(e).slice(0, Object.entries(e).length / 2);
}

export function IsIncluded(current: number, flag: number) {
  return (current & flag) == flag;
}

export function SetFlag(current: number, flag: number): number {
  return current | flag;
}

export function UnsetFlag(current: number, flag: number): number {
  return current & ~flag;
}

export function ToggleFlag(current: number, flag: number, state: boolean) {
  return state ? SetFlag(current, flag) : UnsetFlag(current, flag);
}
